import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import FlowStep from './flowStep'
import FlowHeader from './flowHeader'

const styles = theme => ({
  Container: {
    maxWidth: theme.breakpoints.values['sm'],
    margin: '0 auto',
  },
  Header: {
    marginBottom: 50,
  },
})

class Flow extends React.Component {

  static propTypes = {
    children: PropTypes.node.isRequired,
    stepKey: PropTypes.string.isRequired,
    setStep: PropTypes.func.isRequired,
    reset: PropTypes.bool.isRequired,
    setReset: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    setLoading: PropTypes.func,
    onFinish: PropTypes.func,
    onExit: PropTypes.func,
    containerClass: PropTypes.string,
  }

  static defaultProps = {
    loading: false,
    setLoading: () => {},
    onFinish: () => {},
    onExit: () => {},
  }

  state = {
    back: '',
    next: '',
  }

  constructor(props) {
    super(props)

    if (props.reset === true) {
      this.props.setReset(false)
      this.setStep('')
      this.onRequestNextStep()
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.reset === true && this.props.reset === false) {
      this.props.setReset(false)
      this.setStep('')
      this.onRequestNextStep()
    }
  }

  setStep = (step) => this.props.setStep(step)

  setLoading = (loading) => {
    if (loading !== this.props.loading) this.props.setLoading(loading)
  }

  resetStep = () => {
    this.props.setReset(true)
    this.setStep('')
  }

  getHeader = (children = this.props.children) => {
    let nodes = children
    if (Array.isArray(children) === false) nodes = [children]
    return nodes
      .find(n => typeof n !== 'undefined' && n.type === FlowHeader)
  }

  getSteps = (children = this.props.children) => {
    let nodes = children
    if (Array.isArray(children) === false) nodes = [children]
    return nodes
      .filter(n => typeof n !== 'undefined' && n.type === FlowStep)
      .map(n => {return new Step(n)})
  }

  onRequestNextStep = () => {

    const steps = this.getSteps()
    let currentStepReached = this.props.stepKey === ''

    const isThisOneNext = (step) => {
      if (this.state.next !== '') {
        if (step.getKey() === this.state.next) {
          this.setState({next: ''})
          return Promise.resolve(true)
        } else {
          return Promise.resolve(false)
        }
      }
      if (step.isDefault()) {
        return Promise.resolve(false)
      }
      if (currentStepReached === false) {
        if (step.hasCondition() && step.hasAlwaysCheck()) {
          this.setLoading(true)
          return step.checkCondition()
            .then(conditionMet => {
              if (conditionMet === true) {
                return Promise.resolve(true)
              } else {
                return Promise.resolve(false)
              }
            })
        } else {
          return Promise.resolve(false)
        }
      } else {
        if (step.hasCondition()) {
          this.setLoading(true)
          return step.checkCondition()
            .then(conditionMet => {
              if (conditionMet === true) {
                return Promise.resolve(true)
              } else {
                return Promise.resolve(false)
              }
            })
        } else {
          return Promise.resolve(true)
        }
      }
    }

    const next = (stepIndex) => {
      if (stepIndex >= steps.length) {
        this.props.onFinish()
        this.resetStep()
        this.setLoading(false)
        return
      }

      const step = steps[stepIndex]

      if (step.getKey() === this.props.stepKey) {
        currentStepReached = true
        next(stepIndex + 1)
      } else {
        isThisOneNext(step)
          .then(result => {
            if (result === true) {
              this.setStep(step.getKey())
              this.setLoading(false)
            } else {
              next(stepIndex + 1)
            }
          })
      }
    }

    next(0)
  }

  onRequestSpecificStep = (step, back = '', next = '') => {
    this.setStep(step)
    this.setState({back, next})
  }

  onRequestPreviousStep = () => {
    const steps = this.getSteps()
    let previousStep = ''
    if (this.state.back !== '') {
      this.setStep(this.state.back)
      this.setState({back: ''})
      return
    }
    for (let i = 0; i < steps.length; i++) {
      const step = steps[i]
      if (step.getKey() === this.props.stepKey) {
        if (previousStep === '') {
          break
        } else {
          return this.setStep(previousStep)
        }
      } else {
        if (step.isDefault() === false && step.hasIgnoreWhenBacking() === false) previousStep = step.getKey()
      }
    }
    this.props.onExit()
    this.resetStep()
  }

  onRequestExit = () => {
    this.props.onExit()
    this.resetStep()
  }

  getCurrentStep = () => this.getSteps().find(n => n.getKey() === this.props.stepKey)
  getDefaultStep = () => this.getSteps().find(n => n.isDefault() === true)

  render() {
    const {classes, containerClass, headerClass} = this.props
    const currentStep = this.getCurrentStep()
    const defaultStep = this.getDefaultStep()
    const header = this.getHeader()
    return (
      <div className={containerClass ? containerClass : classes.Container}>
        {header && React.cloneElement(header, {
          back: header.props.back ? {
            show: header.props.back.show,
            onClick: () => {
              this.onRequestPreviousStep()
              if (header.props.back.onClick) header.props.back.onClick()
            },
          } : {},
          close: header.props.close ? {
            show: header.props.close.show,
            onClick: () => {
              if (header.props.close.onClick) {
                header.props.close.onClick()
              } else {
                this.onRequestExit()
              }
            },
          } : {},
          containerClass: headerClass ? headerClass : classes.Header,
        })}
        {currentStep
          ? React.cloneElement(currentStep.getNode(), {
            requestNextStep: this.onRequestNextStep,
            requestPreviousStep: this.onRequestPreviousStep,
            requestExit: this.onRequestExit,
            requestSpecificStep: this.onRequestSpecificStep,
            loading: this.props.loading,
          })
          : defaultStep && React.cloneElement(defaultStep.getNode(), {
          requestNextStep: this.onRequestNextStep,
          requestPreviousStep: this.onRequestPreviousStep,
          requestExit: this.onRequestExit,
          requestSpecificStep: this.onRequestSpecificStep,
          loading: this.props.loading,
        })
        }
      </div>
    )
  }

}

export default withStyles(styles, {withTheme: true})(Flow)

class Step {

  node = null

  constructor(node) {
    this.node = node
  }

  getNode = () => this.node
  hasCondition = () => typeof this.node.props.condition !== 'undefined'
  hasAlwaysCheck = () => this.node.props.alwaysCheck === true
  checkCondition = () => this.node.props.condition()
  getKey = () => this.node.props.stepKey
  isDefault = () => this.node.props.default === true
  hasIgnoreWhenBacking = () => this.node.props.ignoreWhenBacking === true

}



// WEBPACK FOOTER //
// ./src/sections/flow/components/flow.jsx